import subscriptions from "./subscriptions";
import ServicesApi from "./services";
import PropertyApi from "./property";
import GoogleApi from "./google";
import AuthApi from "./auth";
import AjaxApi from "./ajax";
import GroupApi from "./group";
import EventApi from "./event";
import DeviceApi from "./device";

export {
  AuthApi,
  ServicesApi,
  GoogleApi,
  PropertyApi,
  AjaxApi,
  GroupApi,
  EventApi,
  DeviceApi,
  subscriptions,
};

const APIs = {
  subscriptions,
  groups: GroupApi,
  events: EventApi,
  devices: DeviceApi,
  services: ServicesApi,
};

export default APIs;
